import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { AuthLayout, ErrorNote, InfoNote, SubmitButton, INPUT, SECONDARY_BUTTON, LINK } from './AuthLayout'

/**
 * Forgot password: an email with a reset link. The answer is the same whether or not the email has an
 * account; customers who only use WhatsApp (no email, no password) sign in with a WhatsApp code instead.
 */
export default function ForgotPassword() {
  const { requestPasswordReset } = useAuth()
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [sent, setSent] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)
    setLoading(true)
    const result = await requestPasswordReset(email.trim())
    setLoading(false)
    if (result.success) setSent(result.message)
    else setError(result.error)   // e.g. too many requests for this email
  }

  return (
    <AuthLayout title="Forgot password?" subtitle={sent ? 'Check your email' : "We'll email you a link to choose a new one"}>
      <ErrorNote>{error}</ErrorNote>
      {sent ? (
        <>
          <InfoNote>{sent}</InfoNote>
          <button type="button" className={SECONDARY_BUTTON} onClick={() => { setSent(null); setError(null) }}>
            Use another email
          </button>
        </>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4" aria-label="Forgot password">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-1">Email</label>
            <input id="email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className={INPUT} placeholder="The email you signed up with" required />
          </div>
          <SubmitButton loading={loading} busyText="Sending…">Send reset link</SubmitButton>
        </form>
      )}

      <div className="mt-6 space-y-3 text-center text-sm">
        <p className="text-slate-600">
          No email on your account, or you use us on WhatsApp?{' '}
          <Link to="/login/whatsapp" className={LINK}>Get a code on WhatsApp</Link>
        </p>
        <p><Link to="/login" className={LINK}>Back to sign in</Link></p>
      </div>
    </AuthLayout>
  )
}
